import type { FollowBrandClubBlockDTO } from 'autogen/swagger/all';
import FollowButtonWithTooltip from 'components/FollowButton/FollowButtonWithTooltip';
import FlexRow from 'components/Layout/components/Flex/components/FlexRow';
import type { FlexProperties } from 'components/Layout/components/Flex/Flex';
import React from 'react';

export default function FollowButtonPlaceholder(props: FollowBrandClubBlockDTO) {
    const { model, alignmentType } = props;

    if (!model) {
        return null;
    }

    function getJustification(): FlexProperties['justifyContent'] {
        switch (alignmentType) {
            case 'Centered':
                return 'center';
            case 'Right':
                return 'end';
            case 'Left':
            default:
                return 'start';
        }
    }

    return (
        <FlexRow justifyContent={getJustification()}>
            <FollowButtonWithTooltip {...model} />
        </FlexRow>
    );
}
